<template>
  <div class="p-1 ms-2 me-2 ms-lg-4 me-lg-4">
    <div class="md-layout">
        <div class="card col-12">
            <div class="row g-0">
                <button class="btn mode_btn col-12 col-lg-6 btn_border" @click="change_mode_onClick('DMY')" :class="{active: current_mode == 'DMY'}">DMY比較</button>
                <button class="btn mode_btn col-12 col-lg-6 btn_border" @click="change_mode_onClick('INV')" :class="{active: current_mode == 'INV'}"
                style="border-right: 0px !important;" >變流器發電熱流圖</button>
            </div>
        </div>
        <DMYcompare v-if="current_mode=='DMY'"></DMYcompare>
        <INVheatmap v-else-if="current_mode=='INV'"></INVheatmap>
    </div>
  </div>
</template>

<script>
import DMYcompare from "../components/Analysis/DMYcompare.vue"
import INVheatmap from "../components/Analysis/INVheatmap.vue"
export default {
    components:{
        DMYcompare,
        INVheatmap
    },
    data(){
        return {
            current_mode: "DMY", 
        }
    },
    methods: {
        change_mode_onClick(mode){
            this.current_mode = mode
        },
    }
};
</script>
<style>
.mode_btn{
    background-color: transparent;
    border: 0px;
}
.mode_btn.active{
    background-color: orange !important;
}
@media(max-width: 991px){
    #plot_div{
        min-height: 70vh;
    }
}
@media (min-width: 992px) {
    .btn_border{
        border-right: 1px solid #a0a0a0c5 !important;
    }
}
</style>